import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "src/contexts/auth-provider";
import useOutsideClick from "src/hooks/useOutsideClick";

const RightHeaderSection = ({ user }: any) => {
  const navigate = useNavigate();
  const { signOut } = useAuth();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useOutsideClick({ ref, handler: () => setOpen(false) });

  const firstName = user?.storeUser?.firstName ?? "";
  const lastName = user?.storeUser?.lastName ?? "";
  const initials = [firstName.slice(0, 1), lastName.slice(0, 1)]
    .filter(Boolean)
    .join("")
    .toUpperCase() || "?";
  const displayName = [firstName, lastName].filter(Boolean).join(" ") || "Account";

  const handleLogout = () => {
    setOpen(false);
    signOut();
    navigate("/");
  };

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        className="flex items-center gap-2 rounded-lg px-2 py-1.5 hover:bg-slate-100 dark:hover:bg-slate-800"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
        aria-haspopup="true"
      >
        <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#FFF4EE] text-sm font-semibold text-orange">
          {initials}
        </div>
        <div className="hidden flex-col items-start leading-tight sm:flex">
          <span className="text-sm font-medium text-slate-900 dark:text-white">
            {displayName}
          </span>
        </div>
        <svg
          className={`h-4 w-4 shrink-0 text-slate-500 transition-transform ${open ? "rotate-180" : ""}`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          aria-hidden
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {open && (
        <div className="absolute right-0 top-full z-50 mt-2 w-56 rounded-xl border border-black/[0.06] bg-white py-1 shadow-[0_2px_8px_rgba(0,0,0,0.08)] dark:border-white/10 dark:bg-slate-800">
          <button
            type="button"
            className="w-full px-3 py-2.5 text-left text-sm text-[#475569] hover:bg-black/[0.04] dark:text-slate-200 dark:hover:bg-white/10"
            onClick={() => setOpen(false)}
          >
            Profile
          </button>
          <div className="my-1 h-px bg-black/[0.06] dark:bg-white/10" />
          <button
            type="button"
            className="w-full px-3 py-2.5 text-left text-sm text-red-600 hover:bg-black/[0.04] dark:hover:bg-white/10"
            onClick={handleLogout}
          >
            Logout
          </button>
        </div>
      )}
    </div>
  );
};

export default RightHeaderSection;
